import SimpleCryptoJS from 'simple-crypto-js';
import { bcrypt } from './b-crypt';

/*
  https://cpeda.space/socnet/post/157525/  - ENCRYPTION OF TEXT WITH JAVASCRIPT
  https://github.com/softvar/secure-ls
  https://habrahabr.ru/post/349164/ - about local-store
  http://qaru.site/questions/79646/javascript-string-encryption-and-decryption - crypto-js
  https://security.stackexchange.com/questions/93395/how-to-do-client-side-hashing-of-password-using-bcrypt
  https://github.com/dxa4481/clientHashing
  https://habrahabr.ru/post/349164/
*/

export default class Encryption {
  constructor(appKey) {
    this.secretKey = appKey;
    this.crypto = new SimpleCryptoJS(this.secretKey);
  }

  storeHashLocalData() {
    const salt = bcrypt.genSaltSync(6);
    const hash = bcrypt.hashSync(this.secretKey, salt);
    sessionStorage.setItem('rsi-s', salt);
    sessionStorage.setItem('rsi-h', hash);
    this.readHashLocalData();
  }

  readHashLocalData() {
    const salt = sessionStorage.getItem('rsi-s');
    const hash = sessionStorage.getItem('rsi-h');
    const password = bcrypt.compareSync(this.secretKey, hash);
  }

  storeDataWithEncrypt(key, value) {
    // https://www.npmjs.com/package/simple-crypto-js
    // https://stackoverflow.com/questions/4201239/in-html5-is-the-localstorage-object-isolated-per-page-domain

    const encryptValue = this.crypto.encrypt(value);
    sessionStorage.setItem(key, encryptValue);
    this.readDataWithDecrypt(key);
  }

  readDataWithDecrypt(key) {
    const encryptValue = sessionStorage.getItem(key);
    if (!encryptValue) {
      return null;
    }
    const decryptValue = this.crypto.decrypt(encryptValue);
    return decryptValue;
  }
}
